export const ACTION_IN_PROGRESS_NAME = 'actionInProgressName';
export const ACTION_IN_PROGRESS_VALUE = 'actionInProgressValue';
export const DATA = 'data';
export const HUB_ID = 'hubId';
export const SERVER_ID = 'serverId';
export const VALIDATION_MODE_PUBLISH = 'publish';
export const VALIDATION_MODE_DRAFT = 'draft';
export const ORDER_DESCENDING = 'descending';
export const ORDER_ASCENDING = 'ascending';
